import { type RestaurantDetails } from '@discover-data/stores/restaurant/gql/getters/restaurantDetails';
import { lettersOnly } from '@discover-lib/dataFormats';

export const DIETARY_BADGE_LABELS = {
  glutenFree: 'Gluten free options available',
  vegetarian: 'Vegetarian options available',
} as const;

export type DietaryBadgeId = keyof typeof DIETARY_BADGE_LABELS;

// Tag titles come from the CMS, so rename a tag there and this list is the one place to update.
// Vegan shares the vegetarian icon; the ticket treats them as one badge.
const BADGE_TITLE_MATCHERS: Record<DietaryBadgeId, string[]> = {
  glutenFree: ['glutenfree'],
  vegetarian: ['vegetarian', 'vegan'],
};

const BADGE_ORDER: DietaryBadgeId[] = ['glutenFree', 'vegetarian'];

export function getDietaryBadges(tags: RestaurantDetails['tags']): DietaryBadgeId[] {
  const titles = (tags?.edges ?? [])
    .map((edge) => edge?.node)
    .filter((node) => node?.category === 'Dietary' && node.title)
    .map((node) => lettersOnly(node?.title ?? ''));

  return BADGE_ORDER.filter((id) =>
    titles.some((title) => BADGE_TITLE_MATCHERS[id].some((match) => title.includes(match)))
  );
}
